export default "__VITE_ASSET__Bzh240SA__"